import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Sprout, Sparkles, Activity, TrendingUp } from 'lucide-react';

interface SeedsAnalyticsCardsProps {
  totalSeeds: number;
  totalPersonalized: number;
  totalSessions: number;
  overallCompletionRate: number;
}

export function SeedsAnalyticsCards({
  totalSeeds,
  totalPersonalized,
  totalSessions,
  overallCompletionRate,
}: SeedsAnalyticsCardsProps) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Seeds</CardTitle>
          <Sprout className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalSeeds}</div>
          <p className="text-xs text-muted-foreground">in the catalog</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">AI Generated</CardTitle>
          <Sparkles className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalPersonalized}</div>
          <p className="text-xs text-muted-foreground">personalized practices</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Practice Sessions</CardTitle>
          <Activity className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalSessions}</div>
          <p className="text-xs text-muted-foreground">total sessions</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Completion Rate</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{overallCompletionRate}%</div>
          <p className="text-xs text-muted-foreground">sessions completed</p>
        </CardContent>
      </Card>
    </div>
  );
}
